import { render, staticRenderFns } from "./demand-detail.vue?vue&type=template&id=8a980b4e&scoped=true&"
import script from "./demand-detail.vue?vue&type=script&lang=js&"
export * from "./demand-detail.vue?vue&type=script&lang=js&"
import style0 from "./demand-detail.vue?vue&type=style&index=0&id=8a980b4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a980b4e",
  null
  
)

export default component.exports